import * as React from 'react'

import { CircleCountIcon, MessageCircleIcon, MessageSquareIcon } from './'

import {
  CircleCountContainer,
  Container,
  MessageCircleContainer,
  MessageSquareContainer,
} from './styles'

interface IProps {
  count: number
  onClick: () => void
}

const MessageCount = ({ count, onClick }: IProps) => (
  <Container onClick={onClick}>
    <MessageCircleContainer>
      <MessageCircleIcon />
    </MessageCircleContainer>
    <MessageSquareContainer>
      <MessageSquareIcon />
    </MessageSquareContainer>
    {!!count && (
      <CircleCountContainer>
        <CircleCountIcon count={count} />
      </CircleCountContainer>
    )}
  </Container>
)

export default React.memo(MessageCount)
